<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Left side - Hero/Branding -->
      <div class="col-lg-6 d-flex align-items-center justify-content-center bg-primary text-white">
        <div class="text-center">
          <h1 class="display-4 fw-bold mb-4">Join Design.AppVido</h1>
          <p class="lead mb-4">Create your account to access beautiful galleries</p>
          <p class="mb-0">Start your visual journey today</p>
        </div>
      </div>
      
      <!-- Right side - Signup Form -->
      <div class="col-lg-6 d-flex align-items-center justify-content-center">
        <div class="w-100" style="max-width: 400px;">
          <div class="card shadow-lg border-0">
            <div class="card-body p-5">
              <h2 class="card-title text-center mb-4">Create Account</h2>
              
              <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
              </div>
              
              <div v-if="success" class="alert alert-success" role="alert">
                {{ success }}
              </div>
              
              <form @submit.prevent="signup">
                <div class="mb-3">
                  <label for="fullName" class="form-label">Full Name</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="fullName" 
                    v-model="signupForm.full_name"
                    required
                  >
                </div>
                
                <div class="mb-3">
                  <label for="email" class="form-label">Email Address</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email" 
                    v-model="signupForm.email"
                    required
                  >
                </div>
                
                <div class="mb-3">
                  <label for="phone" class="form-label">Phone Number</label>
                  <input 
                    type="tel" 
                    class="form-control" 
                    id="phone" 
                    v-model="signupForm.phone"
                    required
                  >
                </div>
                
                <div class="mb-4">
                  <label for="password" class="form-label">Password</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="password" 
                    v-model="signupForm.password"
                    required
                    minlength="6"
                  >
                  <small class="form-text text-muted">Password must be at least 6 characters</small>
                </div>
                
                <button 
                  type="submit" 
                  class="btn btn-primary w-100 mb-3"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ loading ? 'Creating Account...' : 'Create Account' }}
                </button>
              </form>
              
              <div class="text-center">
                <p class="mb-0">Already have an account? 
                  <router-link to="/" class="text-decoration-none">Sign in here</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SignupPage',
  data() {
    return {
      signupForm: {
        full_name: '',
        email: '',
        phone: '',
        password: ''
      },
      loading: false,
      error: '',
      success: ''
    }
  },
  methods: {
    async signup() {
      this.loading = true
      this.error = ''
      this.success = ''
      
      try {
        await axios.post('https://designappvido-backend.up.railway.app/api/signup', this.signupForm)
        
        this.success = 'Account created successfully! You can now sign in.'
        
        // Reset form
        this.signupForm = {
          full_name: '',
          email: '',
          phone: '',
          password: ''
        }
        
        // Redirect to login after 2 seconds
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
        
      } catch (error) {
        this.error = error.response?.data?.detail || 'Signup failed'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.vh-100 {
  min-height: 100vh;
}

.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.card {
  border-radius: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}
</style>